import { render, staticRenderFns } from "./BigText.vue?vue&type=template&id=3119e0ca&scoped=true&"
import script from "./BigText.vue?vue&type=script&lang=js&"
export * from "./BigText.vue?vue&type=script&lang=js&"
import style0 from "./BigText.vue?vue&type=style&index=0&id=3119e0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119e0ca",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigText.vue
// module id = 238
// module chunks = 0